import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Unsubscribable } from 'rxjs';
import { FavoriteService } from '../../../../_service/favorite/favorite.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../../_service/toast/toast.service';
import { Utility } from '../../../../_service/utility';
import { UserService } from '../../../../_service/user/user.service';


@Component({
  selector: 'app-dropdown-notifications-follows',
  templateUrl: './dropdown-notifications-follows.component.html',
  styleUrls: ['./dropdown-notifications-follows.component.scss',"../dropdown-share.scss"]
})
export class DropdownNotificationsFollowsComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Unsubscribable> = [];
  user;
  followUpdates = [];
  total: number;

  @Input()
  data: any;
  windowActive = true;

  constructor(
    private _favoriteService: FavoriteService,
    private _router: Router,
    private _toastService: ToastService,
    private _userService:UserService,
    private _utility:Utility
  ) {
    window.onblur = () => {
      this.windowActive = false;
      // console.log('非活动窗口');
    };
    window.onfocus = () => {
      this.windowActive = true;
      // console.log('活动窗口');
    };
  }

  ngOnInit(): void {
    this.user = this._userService.user;
    this.subscriptions.push(this._utility.GetOrCreateSubscript("user.newMessage").subscribe(p=>{
      if (this.windowActive) {
        // console.log('活动窗口');
        this.getNewMessage();
      } else {
      }
    }),
    this._userService.userState$.subscribe(p=>{
      this.user = p;
      this.getNewMessage();
    })
    )
  }

  private getNewMessage() {
    if (this.user.id > 0) {
      this.subscriptions.push(
        // this._favoriteService.getFavoriteAttentionNotify(this.user)
        this._favoriteService.getAttentionNotify()
        .subscribe(res => {
       
          this.total = res.total;
          this.followUpdates = res.items.map(r => {
            return {
              ...r,
              lidName: !!r.lidName ? r.lidName : '',
            }
          });
          this._userService.updateNotify({
            follows:this.total
          });

        }))
      // console.log(this.followUpdates.length)
    } else {
      this.total = 0;
      this.followUpdates = [];
      this._userService.updateNotify({
        follows:this.total || 0
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  clearFollowUpdates() {
    if (!this.followUpdates.length) {
      return;
    }
    this._utility.Notify("ClearNotify.follow", this.followUpdates.length);
    this.followUpdates = [];

    this._favoriteService.clearFavoritesAttentionsUpdates(this.user, 3).subscribe(r => {
      if (!!r && r.code === 1) {
        this._toastService.showBlackToast(r.msg);
      }
    });
  }

  msgClick(item) {
    // console.log(item);
    switch (item.actType) {
      case 3:
        this._router.navigate(['/space/', item.uidStr]);
        break;
      case 5:
        this._router.navigate(['/watch'], { queryParams: { v: item.lidStr } });
        break;
      case 6:
        if (item.cid === 1) {
          this._router.navigate(['/play',item.lidStr], { fragment: item.actType === 6 ? 'comments' : null });
        }
        if (item.cid === 3) {
          this._router.navigate(['/watch'], { queryParams: { v: item.lidStr }, fragment: item.actType === 6 ? 'comments' : null });
        }
        break;
      default:
        this._router.navigate(['/play',item.lidStr]);
        break;
    }

    this._favoriteService.updateFavoriteAttentionNotify(item.msgID, 3, item.actType).subscribe(r => {
      // console.log(r);
      // this.followUpdates = this.followUpdates.filter(s => s.msgID !== item.msgID);
      const ifMyVideoHasComment = item.actType === 6;
      if (ifMyVideoHasComment) {
        this.followUpdates = this.followUpdates.filter(s => s.vid !== item.vid); // 清除我的同一个视频下的评论提醒
      } else {
        this.followUpdates = this.followUpdates.filter(s => s.msgID !== item.msgID);
      }
      this._userService.updateNotify({
        follows: this.followUpdates.length,
      });
    });
  }

  nameClick(e) {
    e.stopPropagation();
  }

  textAbstrc(str) {
    return str.replace('<br>', ' ');
  }

  navToActivity(item) {
    this._router.navigate(['/space/', item.uidStr], { queryParams: { type: 'activity', pid: item.lid} });
    this._favoriteService.updateFavoriteAttentionNotify(item.msgID, 3, item.actType).subscribe(r => {
      this.followUpdates = this.followUpdates.filter(s => s.msgID !== item.msgID);
      this._userService.updateNotify({
        follows: this.followUpdates.length,
      });
    });
  }

  navToAlbum(item) {
    this._router.navigate(['/space/', item.uidStr], { queryParams: { type: 'album', a: item.lid} });
    this._favoriteService.updateFavoriteAttentionNotify(item.msgID, 3, item.actType).subscribe(r => {
      this.followUpdates = this.followUpdates.filter(s => s.msgID !== item.msgID);
      this._userService.updateNotify({
        follows: this.followUpdates.length,
      });
    });
  }

}
